import React from "react";
import { ExternalLink, FileSearch } from "lucide-react";
import "./DecisionLieeArticle.css";

const DecisionLieeArticle = ({ articleId, decision, searchQuery }) => {
    const decisions = Array.isArray(decision) ? decision : [];

    if (decisions.length === 0) {
        return (
            <div className="decisions-liees empty-decisions">
                <div className="decisions-header">
                    <h2>Décisions de justice liées</h2>
                </div>
                <p>Aucune décision liée à cet article</p>
            </div>
        );
    }

    return (
        <div className="decisions-liees">
            <div className="decisions-header">
                <h2>Décisions de justice liées</h2>
                {decisions.length > 5 && (
                    <a
                        href={`https://justice.datagreffe.ci/allresult?query=${encodeURIComponent(searchQuery || '')}`}
                        className="voir-toutes"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Voir toutes les décisions
                        <ExternalLink size={14} className="ml-1" />
                    </a>
                )}
            </div>

            <div className="decisions-list">
                {decisions.slice(0, 5).map((dec) => (
                    <div key={dec.id} className="decision-item">
                        <div className="decision-meta">
                            <FileSearch size={18} className="document-icon text-gray-600" />
                            <span className="decision-court">
                                {dec.juridiction} — {dec.reference} — {dec.date_emission}
                            </span>
                        </div>
                        <div className="decision-content">
                            {dec.type_decision && (
                                <p className="decision-type">{dec.type_decision}</p>
                            )}
                            {dec.parties && dec.parties.length > 0 && (
                                <p className="decision-parties">
                                    {dec.parties.map((p) => p.nom).join(" / ")}
                                </p>
                            )}
                            {dec.mots_cles && dec.mots_cles.length > 0 && (
                                <p className="decision-mots-cles">
                                    {dec.mots_cles.join(", ")}
                                </p>
                            )}
                        </div>
                        <div className="decision-actions">
                            <a
                                href={`https://justice.datagreffe.ci/decision/${dec.id}`}
                                className="voir-decision"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FileSearch size={15} />
                                Décision
                            </a>
                        </div>
                    </div>
                ))
                }
            </div >
        </div >
    );
};

export default DecisionLieeArticle;